import Location from './location/location_state';
import DeliveryMethods from './delivery-method/state';
import Statuses from './status/status_state';
import Config from './configs/config_state';
import PaymentMethods from './payment-method/state';

export default {
  namespaced: true,
  modules: {
    Location,
    Statuses,
    DeliveryMethods,
    Config,
    PaymentMethods,
  },
};
